import { lazy, Suspense, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import styles from './BackButton.module.scss'
import { ISaveDraftCallback } from '../../../Models/CategoryFormData'
import { layoutIdInSessionStorage } from '../../../Helpers/Util'
import Loader from '../Loader'

interface BackButtonProps {
  className?: string
  handleOnClick?: any
  label?: string
  isFormUpdated?: boolean
  saveDraftCallback?: ISaveDraftCallback
}

const UnsavedPopup = lazy(() => import('../UnsavedPopup'))

const BackButton = ({
  className,
  handleOnClick,
  label,
  isFormUpdated,
  saveDraftCallback,
}: BackButtonProps) => {
  const [openDialog, setOpenDialog] = useState(false)

  const handleCategorySelection = () => {
    if (isFormUpdated) {
      setOpenDialog(true)
    } else {
      handleOnClick()
    }
  }

  return (
    <>
      {openDialog && (
        <Suspense fallback={<Loader />}>
          <UnsavedPopup
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            onConfirm={async () => {
              await saveDraftCallback?.()
            }}
            onCloseDialog={() => {
              layoutIdInSessionStorage('remove')
              handleOnClick()
            }}
          />
        </Suspense>
      )}
      <div
        className={`${styles.backBtnWrapper} back-btn ${className}`}
        data-testid='backBtnWrapper'
      >
        <div
          data-testid='t-click-btn'
          className={`${styles.leftAerrow}`}
          onClick={handleCategorySelection}
        >
          <KeyboardBackspaceIcon />
        </div>
        <p className={`${className} capitalize`}>{label}</p>
      </div>
    </>
  )
}

export default BackButton
